import { HmacCredentials } from "../types/auth.types";

export const extractHmacFromUrl = (): HmacCredentials | null => {
  const params = new URLSearchParams(window.location.search);

  const signature = params.get("signature") || params.get("secret");
  const timestamp = params.get("timestamp");
  const user_id = params.get("user_id");
  const api_key = params.get("api_key") || params.get("client_id");

  console.log(signature, timestamp, user_id, api_key);

  if (!signature || !timestamp || !user_id || !api_key) {
    return null;
  }

  return { signature, timestamp, user_id, api_key };
};
